module.exports = __webpack_public_path__ + "c4a92730c93597052379c0746230f57b.svg";